import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {StyleSheet, TouchableWithoutFeedback, View} from 'react-native';
import {Text} from 'trpc-react-native-ui';
import Icon from './Icon';
import TextInput from './TripicaTextInput';

class ListItemRadio extends Component {
  _subtitleChanged = subtitle => {
    if (this.props.subtitleChanged) {
      this.props.subtitleChanged({id: this.props.id, subtitle});
    }
  };

  render() {
    const styles = getStyles();
    const {first = false, selected = false} = this.props;
    return (
      <TouchableWithoutFeedback
        onPress={!this.props.isEditing ? this.props.onSelect : undefined}>
        <View
          style={[
            styles.container,
            this.props.isEditing && {justifyContent: 'space-between'},
            first && styles.first,
            selected && !this.props.isEditing && styles.selected,
          ]}>
          {!this.props.isEditing && selected && (
            <Icon color="#d4d4d4" name="roundcheckbox" size={25} />
          )}
          {!this.props.isEditing && !selected && (
            <Icon color="#d4d4d4" name="roundcheckbox-outline" size={25} />
          )}
          <View style={styles.innerContainer}>
            {this.props.isEditing ? (
              <TextInput
                defaultValue={this.props.subtitle}
                onChangeText={this._subtitleChanged}
                placeholder={this.props.subtitlePlaceholder}
                placeholderTextColor="grey"
                style={[styles.subtitle, styles.edition]}
                underlineColorAndroid="grey"
              />
            ) : null}
            {this.props.subtitle && !this.props.isEditing ? (
              <Text style={[styles.title, styles.subtitle]}>
                {this.props.subtitle}
              </Text>
            ) : null}
            <Text style={styles.title}>{this.props.title}</Text>
          </View>
        </View>
      </TouchableWithoutFeedback>
    );
  }
}

ListItemRadio.propTypes = {
  first: PropTypes.bool.isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isEditing: PropTypes.bool,
  onSelect: PropTypes.func,
  selected: PropTypes.bool.isRequired,
  subtitle: PropTypes.string,
  subtitleChanged: PropTypes.func,
  subtitlePlaceholder: PropTypes.string,
  title: PropTypes.string.isRequired,
  sortHandlers: PropTypes.object,
};

function getStyles() {
  return StyleSheet.create({
    container: {
      alignItems: 'center',
      borderColor: '#eeeeee',
      backgroundColor: 'white',
      borderBottomWidth: 1,
      flexDirection: 'row',
      padding: 15,
    },
    edition: {
      flexGrow: 1,
      height: 38,
    },
    first: {
      borderTopWidth: 1,
    },
    innerContainer: {
      paddingHorizontal: 10,
      width: 220,
    },
    selected: {
      backgroundColor: '#f1f1f1',
    },
    subtitle: {
      color: 'grey',
      fontSize: 15,
    },
    title: {
      fontWeight: '600',
    },
    iconContainer: {
      marginRight: 10,
    },
  });
}

export default ListItemRadio;
